import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Location } from '../models/location';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor(private httpClient: HttpClient) {}

  public locations$: BehaviorSubject<Location[]> = new BehaviorSubject<
    Location[]
  >([]);
  getLocations() {
    return this.httpClient
      .get<any>(environment.baseURL + 'odata/Locations?$orderby=LocationName')
      .subscribe((location) => {
        this.locations$.next(location.value);
      });
  }
}
